"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2228],{

/***/ 12228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionEditorialRichText": function() { return /* binding */ SectionEditorialRichText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _SectionQuote_SectionQuote__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14618);
/* harmony import */ var _SectionIconWithTextList_SectionIconWithTextList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89274);
/* harmony import */ var _SectionSingleMediaWithDescription_SectionSingleMediaWithDescription__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79689);
/* harmony import */ var _SectionVideoPlayer_SectionVideoPlayer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96811);
/* harmony import */ var _SectionQuoteWithVideo_SectionQuoteWithVideo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56390);
/* harmony import */ var _SectionStats_SectionStats__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49197);









/**
 *  In this section we use margins (with vw) instead of grid in order to layout the text properly.
 *  This is because grid disables margin collapsing which is used to control spacings between blog sections.
 *  1fr 2fr .25fr => left margin: 30.76vw, right margin: 7.7vw
 */ const StyledContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    "@lg": {
        marginLeft: "30.76vw",
        marginRight: "7.7vw"
    }
});
const PortableTextWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
    maxWidth: "$richTextWidth"
});
const SectionEditorialRichText = (param)=>{
    let { content  } = param;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContainer, {
        type: "NO_MARGIN",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PortableTextWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .PortableText */ .YI, {
                value: content,
                additionalComponents: {
                    types: {
                        sectionQuote: (props)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionQuote_SectionQuote__WEBPACK_IMPORTED_MODULE_3__.SectionQuote, {
                                ...props.value
                            });
                        },
                        sectionIconWithTextList: (props)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionIconWithTextList_SectionIconWithTextList__WEBPACK_IMPORTED_MODULE_4__/* .SectionIconWithTextList */ .Z, {
                                ...props.value
                            });
                        },
                        sectionSingleMediaWithDescription: (props)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionSingleMediaWithDescription_SectionSingleMediaWithDescription__WEBPACK_IMPORTED_MODULE_5__.SectionSingleMediaWithDescription, {
                                ...props.value
                            });
                        },
                        sectionVideoPlayer: (props)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionVideoPlayer_SectionVideoPlayer__WEBPACK_IMPORTED_MODULE_6__/* .SectionVideoPlayer */ .b, {
                                ...props.value
                            });
                        },
                        sectionQuoteWithVideo: (props)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionQuoteWithVideo_SectionQuoteWithVideo__WEBPACK_IMPORTED_MODULE_7__/* .SectionQuoteWithVideo */ .s, {
                                ...props.value
                            });
                        },
                        sectionStats: (props)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionStats_SectionStats__WEBPACK_IMPORTED_MODULE_8__/* .SectionStats */ .d, {
                                ...props.value
                            });
                        }
                    }
                }
            })
        })
    });
};


/***/ }),

/***/ 56390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SectionQuoteWithVideo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30299);
/* harmony import */ var _SectionVideoTestimonials_VideoTestimonial__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78432);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75762);






const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_4__/* .SectionWrapper */ .Uq, {
    gap: "$32",
    display: "grid",
    "@xl": {
        gridTemplateColumns: "340px 1fr"
    },
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    }
});
const Quote = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "heading06",
    marginTop: 0
});
const SectionQuoteWithVideo = (param)=>{
    let { quote , media , personName , personPosition , logo , textColor , backgroundColor , priority  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const [isVideoPlaying, setIsVideoPlaying] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // when the view shifts between mobile and desktop, we want to pause videos to prevent double play
        setIsVideoPlaying(false);
    }, [
        isMd
    ]);
    const handleSlidePlayPause = ()=>setIsVideoPlaying((prevState)=>!prevState);
    const handleOnEnded = ()=>{
        setIsVideoPlaying(false);
    };
    const handleSlideIntersectionChange = (inView)=>{
        if (!inView) {
            setIsVideoPlaying(false);
        }
    };
    const resolvedTextColor = (textColor === null || textColor === void 0 ? void 0 : textColor.rgba) || (textColor === null || textColor === void 0 ? void 0 : textColor.hex);
    const resolvedBackgroundColor = (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.rgba) || (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        css: resolvedBackgroundColor ? {
            backgroundColor: resolvedBackgroundColor
        } : undefined,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .InView */ .df, {
                threshold: 0.6,
                onChange: handleSlideIntersectionChange,
                children: (param)=>/*#__PURE__*/ {
                    let { inView , ref  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionVideoTestimonials_VideoTestimonial__WEBPACK_IMPORTED_MODULE_3__/* .VideoTestimonial */ .N, {
                        ref: ref,
                        media: media,
                        personName: personName,
                        personPosition: personPosition,
                        logo: logo,
                        priority: priority,
                        play: isVideoPlaying,
                        canHideControlsForVideo: isVideoPlaying,
                        inView: inView,
                        handleOnEnded: handleOnEnded,
                        handleSlidePlayPause: handleSlidePlayPause
                    });
                }
            }),
            quote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Quote, {
                    css: resolvedTextColor ? {
                        color: resolvedTextColor
                    } : undefined,
                    children: quote
                })
            })
        ]
    });
};


/***/ }),

/***/ 49197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SectionStats; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StatsWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    rowGap: "$32",
    columnGap: "$32",
    "@md": {
        gridTemplateColumns: "1fr 1fr",
        rowGap: "$72"
    }
});
const Stat = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$16",
    "@md": {
        gap: "$24"
    }
});
const ValueWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "flex"
});
const Value = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    projectFont: "numbers01"
});
const Symbol = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    projectFont: "display02",
    lin: {
        fontSize: [
            30,
            48
        ]
    },
    paddingTop: "$4"
});
const Label = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body03"
});
const SectionStats = (param)=>{
    let { stats  } = param;
    if (!stats || stats.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
        type: "RICH_TEXT_MD",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatsWrap, {
            children: stats.map((param, index)=>/*#__PURE__*/ {
                let { label , value , symbol  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Stat, {
                    children: [
                        value && symbol && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ValueWrap, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Value, {
                                    children: value
                                }),
                                symbol !== "none" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Symbol, {
                                    children: symbol
                                })
                            ]
                        }),
                        label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                            style: {
                                marginTop: 0
                            },
                            children: label
                        })
                    ]
                }, "".concat(index, "-").concat(label));
            })
        })
    });
};


/***/ }),

/***/ 96811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SectionVideoPlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    display: "grid",
    rowGap: "$20"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_06"
});
const SectionVideoPlayer = (param)=>{
    let { video , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        children: [
            video && video.playbackId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
                playbackId: video.playbackId,
                poster: video.firstFrame,
                isAutoPlay: true,
                intersectionObserverOptions: {
                    rootMargin: "200px"
                }
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Description, {
                    children: [
                        "↑ ",
                        description
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 78432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ VideoTestimonial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75762);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61349);
/* harmony import */ var _portfolio_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46115);






const hidingAnimation = {
    transition: "transform .7s, opacity .7s",
    variants: {
        hide: {
            true: {
                transform: "translateY(20px)",
                opacity: "0"
            },
            false: {
                transform: "translateY(0)",
                opacity: "1"
            }
        }
    }
};
const Slide = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    color: "$white",
    display: "grid",
    gap: "$32",
    gridTemplateRows: "max-content",
    alignItems: "center",
    cursor: "pointer",
    "-webkit-tap-highlight-color": "transparent",
    variants: {
        inView: {
            false: {
                pointerEvents: "none",
                cursor: "auto"
            }
        }
    }
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    },
    transform: "translateZ(0)",
    gridColumn: 1,
    gridRow: 1
});
const ContentWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    alignContent: "flex-end",
    gridColumn: 1,
    gridRow: 1,
    height: "100%",
    paddingBottom: "$32",
    gap: "$24",
    zIndex: "$content",
    overflow: "hidden",
    justifyContent: "center",
    justifyItems: "center",
    borderRadius: "calc($r3_mobile - 1px)",
    "@lg": {
        borderRadius: "calc($r3 - 1px)"
    },
    transform: "translateZ(0)",
    transition: "opacity .7s",
    background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))",
    variants: {
        hide: {
            true: {
                opacity: "0.75"
            },
            false: {
                opacity: "1"
            }
        }
    },
    "@md": {
        gap: "$32"
    }
});
const LogoWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    justifySelf: "center",
    maxWidth: 120,
    "@lg": {
        overflow: "hidden",
        height: 50,
        maxWidth: 180,
        width: "100%"
    },
    ...hidingAnimation
});
const TextWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
    ...hidingAnimation
});
const Name = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center"
});
const Position = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center",
    color: "$white_05"
});
const ControlButton = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    display: "flex",
    margin: "0 auto",
    projectFont: "ui01",
    color: "$white",
    alignItems: "center",
    justifyContent: "center",
    gap: "$8",
    zIndex: "$content",
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    }
});
const VideoTestimonial = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { media , personName , personPosition , logo , play , canHideControlsForVideo , priority , handleOnEnded , handleSlidePlayPause , inView , sectionVideos  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("videoTestimonials");
    const hasMobileVideo = (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" && media.mediaPayload.mobileVideo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Slide, {
        onClickCapture: handleSlidePlayPause,
        ref: ref,
        children: [
            media && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                children: (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    disablePlaceholderBackground: true,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    videoOverride: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    },
                    videoOverrideMobile: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && !isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    sizes: "(min-width: 740px) 240px, (min-width: 1000px) 486px, 290px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrap, {
                hide: canHideControlsForVideo,
                children: [
                    sectionVideos && isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                        hide: canHideControlsForVideo,
                        children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                            ...logo,
                            disablePlaceholderBackground: true,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextWrap, {
                        hide: canHideControlsForVideo,
                        children: [
                            personName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                                children: personName
                            }),
                            personPosition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Position, {
                                children: personPosition
                            })
                        ]
                    }),
                    !canHideControlsForVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("play"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Play */ .sh, {})
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("pause"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Pause */ .dz, {})
                        ]
                    })
                ]
            }),
            sectionVideos && !isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                hide: canHideControlsForVideo && isMd,
                children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...logo,
                    disablePlaceholderBackground: true,
                    layout: "intrinsic"
                })
            })
        ]
    });
});


/***/ })

}]);